import { useEffect, useState } from "react"

export const useWindowSize = () =>{
    const [size,setSize] = useState<{width:number,height:number}>({width:window.innerWidth,height:window.innerHeight})

    useEffect(()=>{
        const resize = ()=>{
            setSize({width:window.innerWidth,height:window.innerHeight})
        }
        window.addEventListener("resize",resize)
        return ()=>{
            window.removeEventListener("resize",resize)
        }
    },[])

    return size
}